









































































































import {Component, Mixins, Watch} from 'vue-property-decorator'
import {$, Collection, HttpBody, MixinUpload, PageCollection, pushByName} from 'simpli-web-sdk'
import {UploadConfig} from '@/config/upload.config'
import {AppConfig} from '@/config/app.config'
import RotaSla from '@/model/resource/RotaSla'
import PontaSla from '@/model/resource/PontaSla'
import * as Helper from '@/helpers'
import Papa from 'papaparse'
import {FileObject} from 'image-compressor.js'
import ModalWorkingDays from '@/components/modals/ModalWorkingDays.vue'
import {Action, Getter} from 'vuex-class'
import Responsavel from '@/model/resource/Responsavel'
import ConfigNovaSla from '@/model/resource/ConfigNovaSla'
import {MixinSelect} from '@/components/mixins/MixinSelect'
import {MixinFilter} from '@/components/mixins/MixinFilter'

import ConfigNovaSlaComOrigem from '@/model/resource/ConfigNovaSlaComOrigem'
import CalendarizacaoSla from '@/model/resource/CalendarizacaoSla'
import ConfigNovaSlaCalendarizacao from '@/model/resource/ConfigNovaSlaCalendarizacao'
import {TipoUpload} from '@/enums/TipoUpload'
import {TipoSLA} from '@/enums/TipoSLA'
import PersistConfigNovaSlaRequest from '@/model/request/PersistConfigNovaSlaRequest'
import UploadDados from '@/model/resource/UploadDados'
import {ScreenUpload} from '@/enums/ScreenUpload'
import UploadStatusButton from '@/components/UploadStatusButton.vue'
import {StatusUpload} from '@/enums/StatusUpload'

const metaInfo = () => ({
  title: $.t('view.manage.rotaSla.title'),
})

@Component({
  components: {UploadStatusButton, ModalWorkingDays},
  metaInfo,
})
export default class ManageRotasSlaView extends Mixins(MixinUpload, MixinSelect, MixinFilter) {
  @Getter('auth/responsavel') user!: Responsavel
  @Action('refreshView') refreshView!: Function

  readonly UPLOAD_CONFIG = UploadConfig.buildDataPreset(1)

  AppConfig = AppConfig
  pushByName = pushByName

  collection = new PageCollection(ConfigNovaSla, {}, 10)
  csvCollection = new PageCollection(ConfigNovaSlaCalendarizacao, {})
  csvComOrigemCollection = new PageCollection(ConfigNovaSlaComOrigem, {})

  rotas = new Collection(RotaSla)
  filterOrigem: PontaSla | null = null
  filterDestino: PontaSla | null = null

  lastUpload: UploadDados | null = null
  ScreenUpload = ScreenUpload

  slaType: TipoSLA = TipoSLA.SEM_ORIGEM

  TipoSLA = TipoSLA

  async created() {
    const resp = await ConfigNovaSla.slaType()
    this.slaType = resp.data

    const uploadDados = await UploadDados.getLastUpload(ScreenUpload.CADASTRO_SLA)
    this.lastUpload = uploadDados.data

    this.csvCollection.endpoint = this.csvComOrigemCollection.endpoint = '/user/config-nova-sla/csv'
    if (this.slaType === TipoSLA.ANTIGO) {
      await this.rotas.query()
    }
  }

  get isLastUploadPending() {
    if (this.lastUpload) {
      return this.lastUpload.idStatusUploadFk === StatusUpload.AGUARDANDO_PROCESSAMENTO ||
          this.lastUpload.idStatusUploadFk === StatusUpload.PROCESSANDO
    }
  }

  get allOrigem() {
    const origens = this.rotas.items.map((r) => r.origem)
    const ids = origens.map((i) => i ? i.idPontaSlaPk : -1)
    return origens.filter((o, i) => o && ids.indexOf(o.idPontaSlaPk) === i)
  }

  get allDestino() {
    const destinos = this.rotas.items.map((r) => r.destino)
    const ids = destinos.map((i) => i ? i.idPontaSlaPk : -1)
    return destinos.filter((d, i) => d && ids.indexOf(d.idPontaSlaPk) === i)
  }

  get valorDoResultadoDoFiltro() {
    return this.valorDaOrigemEDestino(this.filterOrigem, this.filterDestino)
  }

  valorDaOrigemEDestino(origem: PontaSla | null, destino: PontaSla | null) {
    const rota = this.rotas.items.find((r) => {
      return (r && r.origem && r.destino && origem && destino
        && r.origem.idPontaSlaPk === origem.idPontaSlaPk
        && r.destino.idPontaSlaPk === destino.idPontaSlaPk) === true
    })
    return rota ? rota.valor : null
  }

  async downloadCsv() {
    if (this.slaType === TipoSLA.ANTIGO) {
      const csv = Papa.unparse([
        [this.$t('view.manage.rotaSla.originDestination'), ...this.allDestino.map((o) => o ? o.$tag : '')],
        ...this.allDestino.map((d) => (!d ? [] : [
          d.$tag, ...this.allDestino.map((o) => o ? this.valorDaOrigemEDestino(o, d) : ''),
        ])),
      ])
      Helper.createCsvFile('rota-sla.csv', csv)
    } else {
      const fetch = () => new HttpBody(String).GET(`/user/config-nova-sla/csv`)
      const url = await $.await.run(fetch, 'download')
      window.open(url.data as string, '_blank')
    }
  }

  openWorkingDays() {
    $.modal.open('workingDays')
  }

  openSetHolidays() {
    this.$router.replace('/manage/sla-holidays/list')
  }

  @Watch('files') // upload
  async filesEvent(files: FileObject[]) {
    if (!files.length) return
    $.await.init('uploadCsv')

    const blueprint = AppConfig.csvBlueprint.configNovaSla
    const data = await Helper.csvToNormalizedData(files[0].file, blueprint)

    const format = (item: any, isSla: boolean = false) => {
      try {
        if (isSla) {
          return Number(item)
        } else {
          return item ? item.toUpperCase() : item
        }
      } catch (e) {
        $.await.done('uploadCsv')
      }
    }

    const formatCalendarizacao = (item: any, dia: string, linha: number) => {
      if (item === '1') {
        return true
      }
      if (item === '0') {
        return false
      }
      $.await.done('uploadCsv')
      throw this.$snotify.error(this.$t(`view.manage.rotaSla.errorCalendarizacao.${dia}`, {line: linha + 2}))
    }

    const request = new PersistConfigNovaSlaRequest()
    request.config = data.map((item, index) => {
      const model = new ConfigNovaSla()
      model.cnpjEmbarcador = format(item.cnpjEmbarcador)
      model.cnpjTransportador = format(item.cnpjTransportador)
      model.ufDestino = format(item.ufDestino)
      model.cidadeDestino = format(item.cidadeDestino)
      model.sla = format(item.sla, true)
      model.nomeTipoVeiculo = item.nomeTipoVeiculo
      model.funcionamento = item.funcionamento

      if (item.seg || item.ter || item.qua || item.qui || item.sex || item.sab || item.dom) {
        model.calendarizacao = new CalendarizacaoSla()
        model.calendarizacao.seg = formatCalendarizacao(item.seg, 'seg', index)
        model.calendarizacao.ter = formatCalendarizacao(item.ter, 'ter', index)
        model.calendarizacao.qua = formatCalendarizacao(item.qua, 'qua', index)
        model.calendarizacao.qui = formatCalendarizacao(item.qui, 'qui', index)
        model.calendarizacao.sex = formatCalendarizacao(item.sex, 'sex', index)
        model.calendarizacao.sab = formatCalendarizacao(item.sab, 'sab', index)
        model.calendarizacao.dom = formatCalendarizacao(item.dom, 'dom', index)
      }

      model.responsavel = this.user
      return model
    })

    try {
      await Helper.importFileToS3(request, TipoUpload.CADASTRO_SLA)
    } finally {
      $.await.done('uploadCsv')
    }

    const upload = await UploadDados.getLastUpload(ScreenUpload.CADASTRO_SLA)
    this.lastUpload = upload.data
    Helper.success('system.info.pleaseWaitForImport')
  }
}
